import React from 'react';

import IconFavorite from '../svg/IconFavorite';

function Empty() {
  return (
    <div className={`flexColumn empty-genre`}>
      <IconFavorite className={`empty-icon`} />
      <span className={`type-title`}>You don't have any favorites yet.</span>
      <span className={`type-regular`}>Star your favorite genres for quicker access.</span>
    </div>
  )
}

export default Empty;
